import { ReportSection } from '../../../types'
import { insights } from '../../../constants'
import getAnomalySubsections from './getAnomalySubsections'
import { TableConnected } from 'elements'

const { NumericCell } = TableConnected as any

type Props = {
  history: any
  reportUrl?: string
  anomalyList: ReportSection[]
  configuredAnomalies: any[]
}

export default function getAnomalyReportSection(props: Props): ReportSection {
  const { history, reportUrl, anomalyList, configuredAnomalies } = props

  return {
    label: 'Anomalies',
    value: 'anomalyInsights',
    route: 'anomaly-insights',
    kind: 'insight',
    onSelect() {
      history.push(`${reportUrl}/${this.route}`)
    },
    dataSections: [
      {
        key: 'anomalyByType',
        title: 'Anomaly By Type',
        data: configuredAnomalies,
        insights: insights.anomalyByType,
        detailRoute: 'anomaly-by-type',
        table: true,
        columns: [
          { Header: 'Anomaly Name', accessor: 'anomalyName', disableSortBy: true },
          { Header: 'Count', accessor: 'count', disableSortBy: true, Cell: NumericCell },
        ],
        tableOptions: {
          initialSortColumns: [{ id: 'count', desc: true }],
          pageSize: 3,
          pagination: true,
          highlightedColumn: 'Anomaly Name',
          preview: true,
          cellProps: () => {
            return {
              pt: 'xlarge',
              pb: 'xlarge',
            }
          },
        },
        subReportSections: getAnomalySubsections({
          reportUrl,
          history,
          anomalyList,
          configuredAnomalies,
        }),
      },
    ],
  }
}
